import { render, staticRenderFns } from "./VslDetVoyage.vue?vue&type=template&id=ec58763a&"
import script from "./VslDetVoyage.vue?vue&type=script&lang=js&"
export * from "./VslDetVoyage.vue?vue&type=script&lang=js&"
import style0 from "./VslDetVoyage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VslDetVoyage.vue"
export default component.exports